/**
 * The agent-side Zendesk URL for a ticket, or null when there is none.
 *
 * Only a numeric id is a real Zendesk ticket — playground sessions carry
 * `pg-…` ids that exist nowhere in Zendesk. The subdomain is re-checked here
 * too: it builds a host, and a malformed one must not become a link.
 */
export function zendeskTicketUrl(
  subdomain: string | null | undefined,
  externalId: string,
): string | null {
  if (!subdomain || !/^[a-z0-9][a-z0-9-]*$/.test(subdomain)) return null;
  if (!/^\d+$/.test(externalId)) return null;
  return `https://${subdomain}.zendesk.com/agent/tickets/${externalId}`;
}
